module.exports = __webpack_public_path__ + "img/img_22.a8edfafe.png";